import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _createReducer;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createReducer } from '@reduxjs/toolkit';
import { DEFAULT_COMBO_INFO, FUB_COMMON_STATUS } from '@beef/elk-common/constants';
import { getExtendedBalanceList } from "../components/Container/ConnectionBlock/utils";
import { ConnectionBlockActionCreator } from "../components/Container/ConnectionBlock/store/actions";
import { PAYLOAD_STATUS_DICTIONARY, REFILLABLE_TYPES } from "../components/Container/ConnectionBlock/constants";
import { ActionCreator } from "./actions";
var initialState = {
  accounts: {
    data: null,
    pending: true,
    error: false
  },
  initData: {
    data: null,
    pending: true,
    error: false
  },
  commonData: {
    data: null,
    pending: true,
    error: false
  },
  notAuthData: {
    data: {
      subtitleDark: 'пополняйте баланс, управляйте услугами и контролируте траты - ',
      subtitleLight: 'мы всегда рядом',
      icon: 'https://static.beeline.ru/upload/images/22631_dark_phone.png',
      googlePlayLink: 'https://play.google.com/store/apps/details?id=ru.beeline.services&hl=ru',
      appleLink: 'https://apps.apple.com/ru/app/moj-bilajn/id569251594',
      huaweiLink: 'https://appgallery.huawei.com/app/C100716739',
      ruStoreLink: 'https://apps.rustore.ru/app/ru.beeline.services',
      qrCode: 'https://static.beeline.ru/upload/images/22631_app_qr_code.png',
      titleLogin: 'профиль',
      titleApp: 'профиль',
      subTitleLogin: 'на сайте',
      subTitleApp: 'в приложении билайн'
    },
    pending: true,
    error: false
  },
  notifications: {
    data: null,
    pending: true
  },
  connectionBlock: {
    mobile: {
      data: null,
      pending: true,
      error: false,
      price: {
        data: null,
        pending: true,
        error: false
      },
      power: {
        data: null,
        pending: true,
        error: false
      },
      superPower: {
        data: null,
        pending: true,
        error: false
      }
    },
    fttb: {
      pending: false,
      error: false,
      data: null
    },
    convergent: {
      pending: false,
      error: false,
      data: null
    }
  },
  fub: {
    mainBalance: null,
    hasMainBalanceError: false,
    mainBalanceLoading: false,
    fubGroupsInfo: {
      data: {
        currentStatus: FUB_COMMON_STATUS.DENY,
        members: [],
        groupCount: 0,
        memberCount: 0
      },
      fubGroupsLoading: false,
      isError: false
    },
    balanceList: null,
    balanceListLoading: false,
    hasBalanceListError: false,
    openedModal: null,
    bonusBalanceDescription: null,
    requiresPostMessage: false
  },
  orangeCombo: {
    isPending: false,
    isError: false,
    data: DEFAULT_COMBO_INFO
  },
  tariff: {
    isPending: false,
    isError: false,
    data: null,
    connection: {
      isPending: false,
      isError: false,
      data: null
    }
  },
  accumulators: {
    isPending: false,
    isError: false,
    data: null
  }
};
export var rootReducer = createReducer(initialState, (_createReducer = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_createReducer, ActionCreator.fetchAccounts.pending.type, function (state) {
  state.accounts.pending = true;
}), ActionCreator.fetchAccounts.fulfilled.type, function (state, action) {
  state.accounts.pending = false;
  state.accounts.error = false;
  state.accounts.data = action.payload;
}), ActionCreator.fetchAccounts.rejected.type, function (state) {
  state.accounts.pending = false;
  state.accounts.error = true;
}), ActionCreator.updateAccountsList.type, function (state, action) {
  state.accounts.data = action.payload;
}), ActionCreator.fetchInitData.pending.type, function (state) {
  state.initData.pending = true;
}), ActionCreator.fetchInitData.fulfilled.type, function (state, action) {
  state.initData.pending = false;
  state.initData.data = action.payload;
}), ActionCreator.fetchInitData.rejected.type, function (state) {
  state.initData.error = true;
}), ActionCreator.fetchCommonData.pending.type, function (state) {
  state.commonData.pending = true;
}), ActionCreator.fetchCommonData.fulfilled.type, function (state, action) {
  state.commonData.pending = false;
  state.commonData.data = action.payload;
}), ActionCreator.fetchCommonData.rejected.type, function (state) {
  state.commonData.error = true;
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_createReducer, ActionCreator.fetchNotAuthData.pending.type, function (state) {
  state.notAuthData.pending = true;
  state.notAuthData.error = false;
}), ActionCreator.fetchNotAuthData.fulfilled.type, function (state, action) {
  state.notAuthData.pending = false;
  state.notAuthData.error = false;
  state.notAuthData.data = action.payload;
}), ActionCreator.fetchNotAuthData.rejected.type, function (state) {
  state.notAuthData.pending = false;
  state.notAuthData.error = true;
}), ActionCreator.fetchNotifications.pending.type, function (state) {
  state.notifications.pending = true;
}), ActionCreator.fetchNotifications.fulfilled.type, function (state, action) {
  state.notifications.pending = false;
  state.notifications.data = action.payload;
}), ActionCreator.fetchNotifications.rejected.type, function (state) {
  state.notifications.pending = false;
}), ActionCreator.fetchOrangeComboInfo.pending.type, function (state) {
  state.orangeCombo.isPending = true;
  state.orangeCombo.isError = false;
}), ActionCreator.fetchOrangeComboInfo.fulfilled.type, function (state, action) {
  state.orangeCombo.data = action.payload;
  state.orangeCombo.isPending = false;
  state.orangeCombo.isError = false;
}), ActionCreator.fetchOrangeComboInfo.rejected.type, function (state) {
  state.orangeCombo.isPending = false;
  state.orangeCombo.isError = true;
}), ConnectionBlockActionCreator.fetchMobileConnection.pending.type, function (state) {
  state.connectionBlock.mobile.pending = true;
  state.connectionBlock.mobile.error = false;
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_createReducer, ConnectionBlockActionCreator.fetchMobileConnection.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.pending = false;
  state.connectionBlock.mobile.data = action.payload;
}), ConnectionBlockActionCreator.fetchMobileConnection.rejected.type, function (state) {
  state.connectionBlock.mobile.pending = false;
  state.connectionBlock.mobile.error = true;
}), ConnectionBlockActionCreator.fetchConnectionPower.pending.type, function (state) {
  state.connectionBlock.mobile.power.pending = true;
  state.connectionBlock.mobile.power.error = false;
}), ConnectionBlockActionCreator.fetchConnectionPower.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.power.pending = false;
  state.connectionBlock.mobile.power.error = false;
  state.connectionBlock.mobile.power.data = action.payload;
}), ConnectionBlockActionCreator.fetchConnectionPower.rejected.type, function (state) {
  state.connectionBlock.mobile.power.pending = false;
  state.connectionBlock.mobile.power.error = true;
}), ConnectionBlockActionCreator.fetchConnectionSuperPower.pending.type, function (state) {
  state.connectionBlock.mobile.superPower.pending = true;
  state.connectionBlock.mobile.superPower.error = false;
}), ConnectionBlockActionCreator.fetchConnectionSuperPower.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.superPower.pending = false;
  state.connectionBlock.mobile.superPower.error = false;
  state.connectionBlock.mobile.superPower.data = action.payload;
}), ConnectionBlockActionCreator.fetchConnectionSuperPower.rejected.type, function (state) {
  state.connectionBlock.mobile.superPower.pending = false;
  state.connectionBlock.mobile.superPower.error = true;
}), ConnectionBlockActionCreator.fetchConnectionPrice.pending.type, function (state) {
  state.connectionBlock.mobile.price.pending = true;
  state.connectionBlock.mobile.price.error = false;
}), ConnectionBlockActionCreator.fetchConnectionPrice.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.price.pending = false;
  state.connectionBlock.mobile.price.data = action.payload;
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPrice.rejected.type, function (state) {
  state.connectionBlock.mobile.price.error = true;
  state.connectionBlock.mobile.price.pending = false;
}), ConnectionBlockActionCreator.fetchBalance.pending.type, function (state) {
  state.fub.hasMainBalanceError = false;
  state.fub.mainBalanceLoading = true;
}), ConnectionBlockActionCreator.fetchBalance.fulfilled.type, function (state, action) {
  if (action.payload.status === PAYLOAD_STATUS_DICTIONARY.SUCCESS) {
    var balance = action.payload.data;
    state.fub.hasMainBalanceError = false;
    state.fub.mainBalance = _objectSpread(_objectSpread({}, balance), {}, {
      refillable: !!REFILLABLE_TYPES[balance === null || balance === void 0 ? void 0 : balance.balanceType]
    });
  } else {
    state.fub.hasMainBalanceError = true;
  }
  state.fub.mainBalanceLoading = false;
}), ConnectionBlockActionCreator.fetchBalance.rejected.type, function (state) {
  state.fub.mainBalanceLoading = false;
  state.fub.hasMainBalanceError = true;
}), ConnectionBlockActionCreator.fetchFubGroups.pending.type, function (state) {
  state.fub.fubGroupsInfo.fubGroupsLoading = true;
  state.fub.fubGroupsInfo.isError = false;
}), ConnectionBlockActionCreator.fetchFubGroups.fulfilled.type, function (state, action) {
  var _action$payload$data;
  if (action.payload.status === PAYLOAD_STATUS_DICTIONARY.SUCCESS && (_action$payload$data = action.payload.data) !== null && _action$payload$data !== void 0 && _action$payload$data.currentStatus) {
    state.fub.fubGroupsInfo.data = action.payload.data;
  } else {
    state.fub.fubGroupsInfo.isError = true;
  }
  state.fub.fubGroupsInfo.fubGroupsLoading = false;
}), ConnectionBlockActionCreator.fetchFubGroups.rejected.type, function (state) {
  state.fub.fubGroupsInfo.fubGroupsLoading = false;
  state.fub.fubGroupsInfo.isError = true;
}), ConnectionBlockActionCreator.fetchFTTBConnection.pending.type, function (state) {
  state.connectionBlock.fttb.pending = true;
  state.connectionBlock.fttb.error = false;
}), ConnectionBlockActionCreator.fetchFTTBConnection.fulfilled.type, function (state, action) {
  state.connectionBlock.fttb.pending = false;
  state.connectionBlock.fttb.error = false;
  state.connectionBlock.fttb.data = action.payload;
}), ConnectionBlockActionCreator.fetchFTTBConnection.rejected.type, function (state) {
  state.connectionBlock.fttb.pending = false;
  state.connectionBlock.fttb.error = true;
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConvergent.pending.type, function (state) {
  state.connectionBlock.convergent.pending = true;
  state.connectionBlock.convergent.error = false;
}), ConnectionBlockActionCreator.fetchConvergent.fulfilled.type, function (state, action) {
  state.connectionBlock.convergent.pending = false;
  state.connectionBlock.convergent.data = action.payload;
}), ConnectionBlockActionCreator.fetchConvergent.rejected.type, function (state) {
  state.connectionBlock.convergent.pending = false;
  state.connectionBlock.convergent.error = true;
}), ConnectionBlockActionCreator.fetchBalances.pending.type, function (state) {
  state.fub.balanceListLoading = true;
  state.fub.hasBalanceListError = false;
  state.fub.balanceList = null;
  state.fub.requiresPostMessage = false;
}), ConnectionBlockActionCreator.fetchBalances.fulfilled.type, function (state, action) {
  if (action.payload.status === PAYLOAD_STATUS_DICTIONARY.SUCCESS) {
    state.fub.hasBalanceListError = false;
    var oldBalance = _objectSpread({}, state.fub.mainBalance);
    var newBalanceList = getExtendedBalanceList(action.payload.data.balanceList);
    state.fub.balanceList = newBalanceList;
    var newMainBalance = newBalanceList.find(function (item) {
      return !!(item !== null && item !== void 0 && item.isMainBalance);
    });
    if (newMainBalance) {
      var _oldBalance$balanceNa, _newMainBalance$balan;
      state.fub.mainBalance = newMainBalance;
      if ((oldBalance === null || oldBalance === void 0 || (_oldBalance$balanceNa = oldBalance.balanceName) === null || _oldBalance$balanceNa === void 0 ? void 0 : _oldBalance$balanceNa.toLocaleLowerCase()) !== (newMainBalance === null || newMainBalance === void 0 || (_newMainBalance$balan = newMainBalance.balanceName) === null || _newMainBalance$balan === void 0 ? void 0 : _newMainBalance$balan.toLocaleLowerCase()) || (oldBalance === null || oldBalance === void 0 ? void 0 : oldBalance.balanceValue) !== (newMainBalance === null || newMainBalance === void 0 ? void 0 : newMainBalance.balanceValue)) {
        state.fub.requiresPostMessage = true;
      }
    }
  } else {
    state.fub.hasMainBalanceError = true;
  }
  state.fub.balanceListLoading = false;
}), ConnectionBlockActionCreator.fetchBalances.rejected.type, function (state) {
  state.fub.balanceListLoading = false;
  state.fub.hasBalanceListError = true;
  state.fub.balanceList = null;
}), ConnectionBlockActionCreator.setMainBalance.pending.type, function (state) {
  state.fub.mainBalanceLoading = true;
  state.fub.hasMainBalanceError = false;
  state.fub.requiresPostMessage = false;
}), ConnectionBlockActionCreator.setMainBalance.fulfilled.type, function (state, action) {
  if (action.payload.status === PAYLOAD_STATUS_DICTIONARY.SUCCESS) {
    var balance = action.payload.data;
    state.fub.hasMainBalanceError = false;
    state.fub.mainBalance = _objectSpread(_objectSpread({}, balance), {}, {
      refillable: !!REFILLABLE_TYPES[balance === null || balance === void 0 ? void 0 : balance.balanceType]
    });
    state.fub.requiresPostMessage = true;
  } else {
    state.fub.hasMainBalanceError = true;
  }
  state.fub.mainBalanceLoading = false;
}), ConnectionBlockActionCreator.setMainBalance.rejected.type, function (state) {
  state.fub.mainBalanceLoading = false;
  state.fub.hasMainBalanceError = true;
}), ConnectionBlockActionCreator.setBonusBalanceDescription.type, function (state, action) {
  state.fub.bonusBalanceDescription = action.payload;
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_createReducer, ConnectionBlockActionCreator.setOpenedModal.type, function (state, action) {
  state.fub.openedModal = action.payload;
}), ConnectionBlockActionCreator.fetchTariff.pending.type, function (state) {
  state.tariff.isPending = true;
  state.tariff.isError = false;
}), ConnectionBlockActionCreator.fetchTariff.fulfilled.type, function (state, action) {
  state.tariff.isPending = false;
  state.tariff.isError = false;
  state.tariff.data = action.payload;
}), ConnectionBlockActionCreator.fetchTariff.rejected.type, function (state) {
  state.tariff.isPending = false;
  state.tariff.isError = true;
}), ConnectionBlockActionCreator.fetchAccumulators.pending.type, function (state) {
  state.accumulators.isPending = true;
  state.accumulators.isError = false;
}), ConnectionBlockActionCreator.fetchAccumulators.fulfilled.type, function (state, action) {
  state.accumulators.isPending = false;
  state.accumulators.isError = false;
  state.accumulators.data = action.payload;
}), ConnectionBlockActionCreator.fetchAccumulators.rejected.type, function (state) {
  state.accumulators.isPending = false;
  state.accumulators.isError = true;
}), ConnectionBlockActionCreator.fetchConnection.pending.type, function (state) {
  state.tariff.connection.isPending = true;
  state.tariff.connection.isError = false;
}), ConnectionBlockActionCreator.fetchConnection.fulfilled.type, function (state, action) {
  state.tariff.connection.isPending = false;
  state.tariff.connection.isError = false;
  state.tariff.connection.data = action.payload;
}), ConnectionBlockActionCreator.fetchConnection.rejected.type, function (state) {
  state.tariff.connection.isPending = false;
  state.tariff.connection.isError = true;
})));